var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1649.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Export",
    transform: "translate(445.000000, 1649.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,0 L28,0 L28,5 L28,20 C25.238,20 23,17.761 23,15 L23,8 L8,23 L5,20 L20,5 L13,5 C10.24,5 8,2.761 8,0 L23,0 Z M24.362,27.637 L23.939,27.637 C24.493,27.637 25.019,27.75 25.515,27.98 C26.009,28.205 26.439,28.518 26.8,28.917 C27.165,29.317 27.455,29.78 27.674,30.307 C27.891,30.833 28,31.387 28,32 L8.058,32 C7.504,32 6.98,31.896 6.484,31.663 C5.989,31.429 5.561,31.114 5.197,30.722 C4.834,30.332 4.544,29.868 4.326,29.334 C4.109,28.799 4,28.234 4,27.637 L24.362,27.637 Z",
    id: 188
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionExport);
export default __webpack_public_path__ + "static/media/navigation-and-action-export.17bb4177.svg";
export { ForwardRef as ReactComponent };